import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { PORTFOLIO } from "../lib/data";
import CTASection from "../components/CTASection";
import { fadeUp } from "../lib/motion";

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = PORTFOLIO.find((p) => p.slug === slug);
  if (!project) return <Navigate to="/portfolio" replace />;
  const others = PORTFOLIO.filter((p) => p.slug !== slug).slice(0, 3);

  return (
    <>
      <section className="pt-6 pb-12">
        <div className="container-page">
          <Link to="/portfolio" className="badge-pill inline-flex mb-6" data-testid="project-back">← Portfolio</Link>
          <motion.div {...fadeUp} className="max-w-4xl">
            <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
              <span>{project.category}</span>
              <span>•</span>
              <span>{project.year}</span>
              <span>•</span>
              <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline">
                {project.link}
              </a>
            </div>
            <h1 className="mt-4 text-4xl md:text-6xl font-extrabold tracking-tighter text-slate-900 dark:text-white leading-[1.02]">
              {project.title}
            </h1>
            <p className="mt-6 text-xl text-slate-600 dark:text-slate-300 leading-relaxed">{project.intro}</p>
          </motion.div>
          <motion.div {...fadeUp} className="mt-12 rounded-[24px] overflow-hidden border border-slate-200 dark:border-slate-800 shadow-2xl">
            <img src={project.cover} alt={project.title} className="w-full h-[380px] md:h-[560px] object-cover" />
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-24" data-testid="project-overview">
        <div className="container-page grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">Overview</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">The brief</h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg text-slate-700 dark:text-slate-200 leading-relaxed">{project.overview}</p>
            <p className="eyebrow mt-10">Objectives</p>
            <ul className="mt-4 space-y-3">
              {project.objectives.map((o) => (
                <li key={o} className="flex items-start gap-3">
                  <Check className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-none mt-1" />
                  <span className="text-slate-700 dark:text-slate-200">{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white dark:bg-slate-950 border-y border-slate-100 dark:border-slate-900" data-testid="project-solution">
        <div className="container-page grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">Solution</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">What we built</h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg text-slate-700 dark:text-slate-200 leading-relaxed">{project.solution}</p>
            <p className="eyebrow mt-10">Technologies</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {project.tech.map((t) => (
                <span key={t} className="badge-pill">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <section className="section" data-testid="project-results">
        <div className="container-page">
          <p className="eyebrow">Results</p>
          <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">Numbers that matter</h2>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {project.results.map((r, i) => (
              <div key={i} className="card-surface p-8">
                <p className="text-5xl font-extrabold tracking-tighter text-blue-600 dark:text-blue-400">{r.value}</p>
                <p className="mt-3 text-slate-600 dark:text-slate-400">{r.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* <section className="section bg-slate-950 text-white" data-testid="project-testimonial">
        <div className="container-page max-w-3xl">
          <p className="eyebrow text-blue-400">Client words</p>
          <blockquote className="mt-6 text-3xl md:text-4xl font-medium leading-tight tracking-tight">
            "{project.testimonial.quote}"
          </blockquote>
          <div className="mt-8 text-slate-300">
            <p className="font-semibold text-white">{project.testimonial.name}</p>
            <p className="text-sm text-slate-400">{project.testimonial.role}</p>
          </div>
        </div>
      </section> */}

      {/* <section className="section" data-testid="project-more">
        <div className="container-page">
          <div className="grid gap-6 md:grid-cols-3">
            {others.map((o) => (
              <Link key={o.slug} to={`/portfolio/${o.slug}`} className="group" data-testid={`more-${o.slug}`}>
                <div className="aspect-[4/3] rounded-[20px] overflow-hidden border border-slate-100 dark:border-slate-800">
                  <img src={o.cover} alt={o.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <h3 className="mt-4 font-semibold text-slate-900 dark:text-white group-hover:text-blue-600 transition-colors">{o.title}</h3>
                <p className="text-sm text-slate-500 dark:text-slate-400">{o.category}</p>
              </Link>
            ))}
          </div>
        </div>
      </section> */}

      <CTASection />
    </>
  );
}
